const DESCRIPTIONS = {
	ONE_OUT_OF_TWO_WIN: '1 out of 2 win',
	ONE_OUT_OF_FOUR_WIN: '1 out of 4 win',
	TWO_OUT_OF_FOUR_WIN: '2 out of 4 win',
	THREE_OUT_OF_FOUR_WIN: '3 out of 4 win',
	ONE_OUT_OF_THREE_WIN: '1 out of 3 win'
};

const RESULT_TYPES_LABEL = {
	WON: 'Won',
	LOST: 'Lost'
};

const GAME_NAME = 'gameName';

type RegistrationFilters = {
	registeredFrom?: number;
	registeredTill?: number;
	tournamentID?: number;
	gameName?: string;
	pwfInviteId?: string;
	tournamentType?: string;
	gameType?: string;
};

export { DESCRIPTIONS, RESULT_TYPES_LABEL, GAME_NAME };

export type { RegistrationFilters };
